import { Button } from 'antd';
import noop from 'lodash/noop';
import moment from 'moment-timezone';
import React from 'react';

import { ModalMask } from '@components/common';
import { uuidv4 } from '@utils';

import Calendar from './Calendar';
import Display from './Display';
import TimeSelector from './TimeSelector';
import styles from './styles/DayPicker.less';

class DayPicker extends React.PureComponent {
  constructor(props) {
    super(props);
    const { defaultValue } = this.props;
    this.state = {
      open: false,
      interval: defaultValue,
    };
    this.display = React.createRef();
    this.modalId = uuidv4();
  }

  componentDidMount() {
    this.display.current.addEventListener('click', this.toggleOpen);
    document.addEventListener('mousedown', this.clickModalBg);
  }

  componentWillUnmount() {
    this.display.current.removeEventListener('click', this.toggleOpen);
    document.removeEventListener('mousedown', this.clickModalBg);
  }

  render() {
    const { disabledDate, title, className, expanded, granularity } = this.props;
    const { displayShortcut, open, interval } = this.state;
    return (
      <>
        {open && <ModalMask id={this.modalId} />}
        <div className={styles.dayPicker}>
          <div ref={this.display}>
            <Display
              expanded={expanded}
              className={className}
              interval={interval}
              selected={open}
              title={title}
              shortcut={displayShortcut}
            />
          </div>
          {open && (
            <div className={styles.popup}>
              <Calendar
                type="day"
                defaultValue={interval}
                onChange={this.onDayChange}
                disabledDate={disabledDate}
              />
              <div className={styles.timeSelector}>
                <TimeSelector
                  time={interval[0]}
                  onChange={this.onTimeChange}
                  granularity={granularity}
                />
              </div>
              <Button className={styles.applyBtn} type="primary" ghost onClick={this.onApply}>
                Apply
              </Button>
            </div>
          )}
        </div>
      </>
    );
  }

  clickModalBg = (e) => {
    const { onCancel } = this.props;
    if (e.target.id === this.modalId) {
      onCancel();
      this.toggleOpen();
    }
  };

  close = () => {
    const { onClose } = this.props;
    onClose();
    this.setState({
      open: false,
    });
  };

  reset = () => {
    const { defaultValue } = this.props;
    this.setState({
      interval: defaultValue,
    });
  };

  setDate = (interval) => {
    this.setState({
      interval,
    });
  };

  toggleOpen = () => {
    const { onClose, onOpen, defaultValue } = this.props;
    const { open } = this.state;
    if (open) {
      onClose();
      this.setState({
        open: false,
        interval: defaultValue,
      });
    } else {
      onOpen();
      this.setState({ open: true });
    }
  };

  getEndTime = (start) => {
    const { defaultValue } = this.props;
    const [from, to] = defaultValue;
    const diff = moment(to).diff(from, 'minutes');
    return moment(start).add(diff, 'minutes');
  };

  onDayChange = (date) => {
    const { onChange } = this.props;
    const newInterval = [date, this.getEndTime(date)];
    onChange(newInterval);
    this.setState({
      interval: newInterval,
    });
  };

  onTimeChange = (time) => {
    const { interval } = this.state;
    const [hour, minute] = time.label.split(':');
    const start = interval[0].hour(hour).minute(minute).startOf('minute');
    this.setState({
      interval: [start, this.getEndTime(start)],
    });
  };

  onApply = () => {
    const { onApply, onClose } = this.props;
    const { interval } = this.state;
    onApply(interval[0]);
    onClose();
    this.setState({
      open: false,
    });
  };
}

DayPicker.defaultProps = {
  className: '',
  defaultValue: [],
  disabledDate: noop,
  title: '',
  expanded: false,
  granularity: 5,
  onOpen: noop,
  onClose: noop,
  onChange: noop,
  onApply: noop,
  onCancel: noop,
};

export default DayPicker;
